import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { round } from '../SuskaiciuotasAtsakymas';

const QuestionItem = ({ 
    title,
    years,
    visi,
    visiPilni,
    showComparison,
    onTitleClick,
    t
}) => {
    const titleText = title.name.replace(/^\d+\.\d+\.\d+:\s*/, '');

    return (
        <div className="question">
            <div className="title">
                <Link
                    sx={{ textAlign: "start" }}
                    color="inherit"
                    component="button"
                    fontWeight={400}
                    fontSize={16}
                    lineHeight={1.5}
                    underline="hover"
                    onClick={() => {
                        onTitleClick(title.name)
                    }}
                >
                    {t(titleText)}
                </Link>
            </div>
            <div className="anwsers">
                {years.map((year, index) => (
                    <div key={`${year}-${index}`} className="balas tooltip">
                        <div className="mobile metai">{year}</div>
                        <div className="balas">
                            <div className="mobile metai">{year}</div>
                            <div className="atsakmyasRezultatas">
                                {(year === '2023' || year === '2024') && !visi[year]?.[title.name] ? (
                                    t('nevertinama')
                                ) : (
                                    <>
                                        {visi[year]?.[title.name] ? round(visi[year][title.name], 0.5) : '0'}
                                        {showComparison && visiPilni[year] && (
                                            <Tooltip title={t('palyginus_su_vidurkiu')} placement="top">
                                                <span className="atsakmyasRezultatasPilkas">
                                                    ({visiPilni[year]?.[title.name] ? round(visiPilni[year][title.name], 0.5) : '0'})
                                                </span>
                                            </Tooltip>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

QuestionItem.propTypes = {
    title: PropTypes.shape({
        name: PropTypes.string.isRequired
    }).isRequired,
    years: PropTypes.arrayOf(PropTypes.string).isRequired,
    visi: PropTypes.object.isRequired,
    visiPilni: PropTypes.object.isRequired,
    showComparison: PropTypes.bool.isRequired,
    onTitleClick: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired
};

export default memo(QuestionItem);
